import { render } from "./roundCamera.vue?vue&type=template&id=b54802c0"
import script from "./roundCamera.vue?vue&type=script&lang=js"
export * from "./roundCamera.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__